import { LocalStorage } from '../utils/storage'

const FEATURE_FLAGS_KEY = 'feature_flags'

export const FeatureFlagsService = {
  getFeatureFlags: () => {
    const featureFlags = LocalStorage.get(FEATURE_FLAGS_KEY, [])
    return Array.isArray(featureFlags) ? featureFlags : []
  },
  isFeatureEnabled: (featureKey) => {
    if (!featureKey) return false

    const featureFlags = FeatureFlagsService.getFeatureFlags()
    return featureFlags.some((flag) => flag === featureKey)
  },
  barcodeEnabled: () => FeatureFlagsService.isFeatureEnabled('barcode'),
  filteredDistributionEnabled: () => FeatureFlagsService.isFeatureEnabled('filtered_distribution'),
  distributionsEditableEnabled: () => FeatureFlagsService.isFeatureEnabled('distributions_editable'),
  expirationAlertEnabled: () => FeatureFlagsService.isFeatureEnabled('expiration_alert'),
  autogenerateBatchRequestsEnabled: () => FeatureFlagsService.isFeatureEnabled('autogenerate_batch_requests'),
  autogenerateBatchDatetimeEnabled: () => FeatureFlagsService.isFeatureEnabled('autogenerate_batch_datetime'),
  productOrdersEnabled: () => FeatureFlagsService.isFeatureEnabled('product_orders'),
  productOrdersStrictEnabled: () => FeatureFlagsService.isFeatureEnabled('product_orders_strict'),
  stockSnapshotsEnabled: () => FeatureFlagsService.isFeatureEnabled('stock_snapshots'),
}
